export default __webpack_public_path__ + "static/carregador-ffb30dd229e7d54baad45e2907581ab8.png";